// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3a8ad2e2","455":"18afe277","977":"e82e33c3"}[chunkId] + ".chunk.js";
};